import { format } from '@utils/string';
import { getProductConfigURL } from '@services/urls/apiGatewayURLs';
import { SHOP_DELIVERY_TYPE } from '@shared/constants';
import ServiceResponse from '../models/ServiceResponse';

const message = 'productId params are required';

async function getProductConfig({
  axios,
  productId,
  shopId,
  occasion = SHOP_DELIVERY_TYPE.DELIVERY,
}) {
  try {
    if (!productId || !shopId) return new ServiceResponse({ error: message });

    const query = `includeOptionsWithoutStock=true&occasion=${occasion}`;

    const url = format(getProductConfigURL, shopId, productId, query);
    const { data } = await axios.get(url);

    return new ServiceResponse({ data });
  } catch (error) {
    return new ServiceResponse({ error });
  }
}

export default getProductConfig;
